import { render, staticRenderFns } from "./TagtForm.vue?vue&type=template&id=706f417c"
import script from "./TagtForm.vue?vue&type=script&lang=js"
export * from "./TagtForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports